import $ from "jquery";
import Rellax from "Rellax";
import { isNotPC } from "./ua";


export default class Parallax {
  constructor() {}

  init() {
    if (isNotPC()) {
      $(".rellax").each((index, element) => {
        const speed = $(element).data("rellax-speed");
        element.setAttribute("data-rellax-speed", speed * 0.5);
      });

      new Rellax(".rellax-sp", {
        center: true
      });
    } else {
      new Rellax(".rellax-pc", {
        center: true
      });
    }

    new Rellax(".rellax", {
      center: true
    });
  }
}



// WEBPACK FOOTER //
// ./src/js/modules/Parallax.js